import React, { FC } from 'react';

import styles from './connection_error.module.scss';

type Props = {
  error: string;
};

export const ConnectionError: FC<Props> = ({ error }) => {
  return (
    <div
      className={styles.error}
      dangerouslySetInnerHTML={{ __html: error }}
      data-test-id="login-error"
    />
  );
};
